import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=128bdcbb&scoped=true&"
import script from "./Consume.vue?vue&type=script&lang=js&"
export * from "./Consume.vue?vue&type=script&lang=js&"
import style0 from "./Consume.vue?vue&type=style&index=0&id=128bdcbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128bdcbb",
  null
  
)

export default component.exports